const authBaseUrl = String(import.meta.env.VITE_AUTH_BASE_URL ?? '').trim().replace(/\/$/, '');

/**
 * Runtime configuration for coolture_demo (Vite env).
 */
export const Configs = {
  authBaseUrl,
  loginApiUrl: authBaseUrl ? `${authBaseUrl}/api/authentication/post/login/` : '',
  logoutApiUrl: authBaseUrl ? `${authBaseUrl}/api/authentication/post/logout/` : '',
  privateKey: String(import.meta.env.VITE_PRIVATE_KEY ?? '').trim(),
  unauthenticatedApiToken: String(
    import.meta.env.VITE_UNAUTHENTICATED_REQUESTS_API_TOKEN ?? ''
  ).trim(),
  /** Required by coolture_auth `POST /login/` (`X-Kincode-Client-Id`). */
  kincodeClientId: String(import.meta.env.VITE_KINCODE_CLIENT_ID ?? 'demo-web-local').trim(),
  isDev: import.meta.env.DEV,
} as const;
